/** biome-ignore-all lint/complexity/noExcessiveLinesPerFunction: TODO: refactor */
import i18n from 'i18next';
import moment from 'moment';

import { getLocalDateTime } from '@/utils/date';
import type { ShipmentSearchFilters } from '@/views/screens/Shipment/types';

import { DEFAULT_DATE_FORMAT, SORTING_ORDERS } from './common';

export const SHIPMENT_EXPORT_SHIPMENT_INFORMATION_FIELDS = (isShowBusinessJustification: boolean) => [
  {
    label: i18n.t('translation:default.fields.shipmentNumber.label'),
    name: 'shipmentNo',
  },
  {
    label: i18n.t('translation:default.fields.shipmentStatus'),
    name: 'status',
  },
  {
    label: i18n.t('translation:default.fields.shipmentTerms.label'),
    name: 'shipmentTermsDesc',
  },
  {
    label: i18n.t('translation:default.fields.expectedShipDate.label'),
    name: 'expShipDate',
  },
  {
    label: i18n.t('translation:default.fields.expectedDeliveryDate'),
    name: 'expDeliveryDate',
  },
  { label: i18n.t('translation:default.fields.multiStop'), name: 'multiStop' },
  {
    label: i18n.t('translation:default.fields.shipperName.label'),
    name: 'shipperName',
  },
  {
    label: i18n.t('translation:default.fields.shipperCountry.label'),
    name: 'shipperCountryCode',
  },
  {
    label: i18n.t('translation:default.fields.shipperPostalCode'),
    name: 'shipperZip',
  },
  {
    label: i18n.t('translation:default.fields.shipperState'),
    name: 'shipperState',
  },
  {
    label: i18n.t('translation:default.fields.shipperCity.label'),
    name: 'shipperCity',
  },
  {
    label: i18n.t('translation:default.fields.shipperPortType'),
    name: 'shipperPortType',
  },
  {
    label: i18n.t('translation:default.fields.consigneeName.label'),
    name: 'consigneeName',
  },
  {
    label: i18n.t('translation:default.fields.consigneeCountry.label'),
    name: 'countryCode',
  },
  {
    label: i18n.t('translation:default.fields.consigneePostalCode.label'),
    name: 'consigneeZip',
  },
  {
    label: i18n.t('translation:default.fields.consigneeState.label'),
    name: 'consigneeState',
  },
  {
    label: i18n.t('translation:default.fields.consigneeCity.label'),
    name: 'consigneeCity',
  },
  {
    label: i18n.t('translation:default.fields.consigneePortType'),
    name: 'consigneePortType',
  },
  {
    label: i18n.t('translation:default.fields.chargebleWeight'),
    name: 'totalWeight',
  },
  { label: i18n.t('translation:default.fields.weightUOM'), name: 'weightUom' },
  { label: i18n.t('translation:default.fields.billQty'), name: 'totalUnits' },
  {
    label: i18n.t('translation:default.fields.packageBilledQuantityunitOfMeasure'),
    name: 'uom',
  },
  {
    label: i18n.t('translation:default.fields.palletLoadType.label'),
    name: 'palletLoadType',
  },
  { label: i18n.t('translation:default.fields.cube.label'), name: 'totalCube' },
  {
    label: i18n.t('translation:default.fields.shipmentCargoType'),
    name: 'shipmentCargoType',
  },
  {
    label: i18n.t('translation:default.fields.shipmentTransportationProvider'),
    name: 'shipmentTransportationProvider',
  }, //->?
  {
    label: i18n.t('translation:default.fields.incoTerm.label'),
    name: 'incoTerms',
  },
  {
    label: i18n.t('translation:default.fields.shipmentCost'),
    name: 'rateShopCost',
  },
  {
    label: i18n.t('translation:shipment.drawer.details.distanceMiles'),
    name: 'totalMileage',
  },
  {
    label: i18n.t('translation:shipment.drawer.details.distanceKm'),
    name: 'totalKm',
  },
  { label: i18n.t('translation:default.fields.notes'), name: 'shipmentNotes' },
  {
    label: isShowBusinessJustification
      ? i18n.t('translation:default.fields.businessJustification.label')
      : i18n.t('translation:default.fields.internalNotes.label'),
    name: 'detailNotes',
  },
  {
    label: i18n.t('translation:default.fields.printedBillOfLading'),
    name: 'bolPrinted',
  },
  {
    label: i18n.t('translation:default.fields.createdOn.title'),
    name: 'createdOn',
  },
  {
    label: i18n.t('translation:default.fields.createdByFullName'),
    name: 'fullName',
  },
  {
    label: i18n.t('translation:default.fields.createByEmailAddress'),
    name: 'userEmail',
  },
  {
    label: i18n.t('translation:default.fields.modifiedOn'),
    name: 'modifiedOn',
  },
  {
    label: i18n.t('translation:default.fields.modifiedBy'),
    name: 'modifiedFullName',
  },
  {
    label: i18n.t('translation:default.fields.lspStationCode.label'),
    name: 'lspStationCode',
  },
  {
    label: i18n.t('translation:default.fields.serviceType.label'),
    name: 'serviceType',
  },
  {
    label: i18n.t('translation:default.fields.branchDesc.label'),
    name: 'BranchDesc',
  },
  {
    label: i18n.t('translation:default.fields.laneID.label'),
    name: 'LaneID',
  },
];

export const SHIPMENT_EXPORT_SHIPMENT_ADDITIONAL_INFORMATION_FIELDS = () => [
  {
    label: i18n.t('translation:default.fields.masterBOLNo'),
    name: 'masterBolNumber',
  },
  { label: i18n.t('translation:default.fields.houseBOLNo'), name: 'bolNumber' },
  {
    label: i18n.t('translation:default.fields.containerNumber.label'),
    name: 'containerNumber',
  },
  {
    label: i18n.t('translation:default.fields.masterShipmentNo'),
    name: 'masterShipmentNo',
  },
  {
    label: i18n.t('translation:default.fields.transportationProviderAppointmentNumber'),
    name: 'isTpaSelected', // -> *
  }, //->?
  {
    label: i18n.t('translation:default.fields.freightBillNumber'),
    name: 'proNo',
  }, //->?
  {
    label: i18n.t('translation:default.fields.displayStopOffs'),
    name: 'isDisplayStopShow',
  }, //->? // -> *
  {
    label: i18n.t('translation:default.fields.purchaseOrderNumber'),
    name: 'poNumber',
  },
  {
    label: i18n.t('translation:default.fields.salesOrderNumber'),
    name: 'soNumber',
  },
  {
    label: i18n.t('translation:default.fields.partNumber'),
    name: 'partNumber',
  },
  {
    label: i18n.t('translation:default.fields.partNumberDescription'),
    name: 'partDescription',
  },
  {
    label: i18n.t('translation:default.fields.partSerialNumber'),
    name: 'partSerialNumber',
  },
  {
    label: i18n.t('translation:shipmentAdd.shipmentDetails.transportationPO.label'),
    name: 'transportationPO',
  },
  {
    label: i18n.t('translation:default.fields.freightClass.label'),
    name: 'FreightClass',
  },
  {
    label: 'Consignee Trailer Number',
    name: 'ConsigneeTrailerNumber',
  },
];

export const SHIPMENT_EXPORT_SHIPMENT_RATE_DETAILS_FIELDS = () => [
  {
    label: i18n.t('translation:default.fields.pricingBasis.label'),
    name: 'pricingBasis',
  }, // -> *
  {
    label: i18n.t('translation:default.fields.rateSubmittedOn'),
    name: 'rateSubmittedOn',
  }, // -> *
  {
    label: i18n.t('translation:default.fields.transportationProvider.label'),
    name: 'carrierName',
  }, // -> *
  { label: i18n.t('translation:default.fields.cost'), name: 'cost' }, // -> *
  {
    label: i18n.t('translation:default.fields.costCurrency'),
    name: 'convertedCurrency',
  }, // -> *
  {
    label: i18n.t('translation:default.fields.shipmentCancelCost'),
    name: 'shipmentCancelCost',
  }, // -> *
  {
    label: i18n.t('translation:default.fields.shipmentCancelCostCurrency'),
    name: 'shipmentCancelCostCurrency',
  }, // -> *
  {
    label: i18n.t('translation:default.fields.showAllSpotBidCarrier'),
    name: 'showSpotBidCarrier',
  }, //->? // -> *
  {
    label: i18n.t('translation:default.fields.cargoType.label'),
    name: 'cargoType',
  }, // -> *
  {
    label: i18n.t('translation:default.fields.serviceLevel.label'),
    name: 'serviceLevel',
  }, // -> *
  {
    label: i18n.t('translation:default.fields.transitDays'),
    name: 'stdTransitDay',
  }, // -> *
  {
    label: i18n.t('translation:default.fields.rateStatus'),
    name: 'rateStatus',
  }, // -> *
];

export const SHIPMENT_RATE_SHOP_RESULTS_EXPORT_COLUMNS = [
  { name: 'RateShopKey' },
  { name: 'Transportation Provider' },
  { name: 'Converted Price' },
  { name: 'Converted Currency Code' },
  { name: 'Pricing Basis' },
  { name: 'Standard Transit Days' },
  { name: 'Cargo Type' },
  { name: 'Service Description' },
  { name: 'Equipment Type' },
  { name: 'Equipment Type Detail' },
  { name: 'User Submitted' }, // ->?
  { name: 'Created On' },
  { name: 'Bid Expiry Date' }, // ->?
  { name: 'Bid Comment' },
  { name: 'Spot Quote Number' },
];

export const SHIPMENT_FOOTER_TYPES = {
  LATE_DELIVERY: 'LD',
  LATE_PICKUP: 'LP',
  MISSING_DOCUMENTS: 'MD',
  PICKUP_FAILED: 'PF',
  TRACKING_FAILURES: 'TF',
} as const;

export const SHIPMENT_RATE_SHOP_RATTING_PREFERENCES = {
  ALL_CARRIERS: 'ALL',
  LEAST_COST: 'LC',
  REQUIRED: 'REQ',
};

export const SHIPMENT_TRACKING_TYPES = {
  DHL: 'DHL',
  FEDEX: 'FEDEX',
  UPS: 'UPS',
};

export const SHIPMENT_PRINTS_TAB_ID = {
  BOL: '3',
  CMR: '6',
  COMMERCIAL_INVOICE: '1',
  IMO: '4',
  PACKING_LIST: '2',
  SED: '5',
};

export const SHIPMENT_PRINTS_DOC_TYPES = {
  [SHIPMENT_PRINTS_TAB_ID.COMMERCIAL_INVOICE]: 'CI',
  [SHIPMENT_PRINTS_TAB_ID.PACKING_LIST]: 'PL',
  [SHIPMENT_PRINTS_TAB_ID.BOL]: 'BOL',
  [SHIPMENT_PRINTS_TAB_ID.CMR]: 'CMR',
  [SHIPMENT_PRINTS_TAB_ID.SED]: 'SED',
};

export const SHIPMENT_PRINTS_ENABLED_STATUS = [
  'Tender',
  'Auto-Tendered',
  'In-Transit',
  'Confirmed',
  'Approved',
  'Closed',
];

export const SHIPMENT_NOTIFICATION_DISTRIBUTORS_SORTING_FIELDS = [
  {
    label: i18n.t('translation:default.fields.distributorName'),
    value: 'distributionName',
  },
  { label: i18n.t('translation:default.fields.status.label'), value: 'status' },
  {
    label: i18n.t('translation:default.fields.description'),
    value: 'description',
  },
];

export const SHIPMENT_NOTIFICATION_ROUTING_SORTING_FIELDS = () => [
  {
    label: i18n.t('translation:default.fields.routingType.label'),
    value: 'routingTypeName',
  },
  { label: i18n.t('translation:default.fields.status.label'), value: 'status' },
  {
    label: i18n.t('translation:default.fields.transportationProvider.label'),
    value: 'carrierName',
  },
  {
    label: i18n.t('translation:default.fields.userName.label'),
    value: 'userName',
  },
  {
    label: i18n.t('translation:default.fields.cargoType.label'),
    value: 'cargoName',
  },
  {
    label: i18n.t('translation:default.fields.branch.label'),
    value: 'branchName',
  },
  {
    label: i18n.t('translation:default.fields.country.label'),
    value: 'countryName',
  },
  {
    label: i18n.t('translation:default.fields.locationType.label'),
    value: 'locationTypeName',
  },
];

export const GET_QUOTE_FORM_IDS = {
  productForm: '3',
  quoteDetailsForm: '1',
  stopsForm: '2',
  transportationProviderSearchForm: '4',
};

export const SHIPMENT_STOP_TYPES = {
  DEST: 'DEST',
  ORIGIN: 'ORIGIN',
};

export const DEFAULT_RATE_SHOP_ITEMS_VALUE = {
  billedWeight: 0,
  billQuantity: 0,
  cube: 0,
  height: 0,
  length: 0,
  numberOfPieces: 0,
  selected: false,
  width: 0,
};

export const GLOBAL_RATE_SHOP_FORM_DEFAULT_VALUES = {
  branchKey: -1,
  CODValue: 0,
  currencyCode: 'USD',
  declaredValue: 0,
  LDMValue: 0,
  measurementUit: 'LB',
  pricingBasis: '**',
  pricingType: 'PACT',
  shipmentTerms: 'P',
  shipmentType: 'O',
  timeFrame: 'C',
  trailerKey: -1,
};

export const DEFAULT_SHIPMENT_TABLE_VIEW_COLUMNS = [
  {
    columnName: 'Shipment Status',
    columnValue: 'status',
  },
  {
    columnName: 'Multi Stop',
    columnValue: 'multiStop',
  },
  {
    columnName: 'Transportation provider',
    columnValue: 'carrierName',
  },
  {
    columnName: 'Origin',
    columnValue: 'shipper',
  },
  {
    columnName: 'Destination',
    columnValue: 'consignee',
  },
  {
    columnName: 'Shipment Cost',
    columnValue: 'rateShopCost',
  },
  {
    columnName: 'Currency',
    columnValue: 'convertedCurrency',
  },
  {
    columnName: 'Approval No',
    columnValue: 'approvalNumber',
  },
  {
    columnName: 'Quote No',
    columnValue: 'quoteNo',
  },
];

export const HAZMAT_VALUES = {
  N: 'No',
  n: 'No',
  Y: 'Yes',
  y: 'Yes',
};

export const SHIPMENT_STOP_TYPE_LABEL = {
  1: 'Pickup',
  2: 'Delivery',
};

export const SHIPMENT_FOB_CODE_LABEL = {
  DEST: 'Destination',
  ORIG: 'Origin',
};

export const getShipmentDefaultFilters = (): ShipmentSearchFilters => ({
  ApprovalNumber: undefined,
  BolNumber: undefined,
  BranchKey: undefined,
  CargoType: undefined,
  CarrierKey: undefined,
  CCountryCode: undefined,
  ConsigneeCity: undefined,
  ConsigneeName: undefined,
  ConsigneeState: undefined,
  ConsigneeZip: undefined,
  CreatedDateFrom: moment(getLocalDateTime()).subtract(1, 'months'),
  CreatedDateTo: moment(getLocalDateTime()),
  createdBy: undefined,
  ExpShipFrom: undefined,
  ExpShipTo: undefined,
  IncoTerms: undefined,
  modifiedBy: undefined,
  OCountryCode: undefined,
  OrderByColumn: 'CreatedOn',
  OrderBySort: SORTING_ORDERS.DESC,
  PageNumber: 1,
  PageSize: 20,
  PoNo: undefined,
  ProjectNo: undefined,
  QuoteNo: undefined,
  ShipmentNo: undefined,
  ShipmentStatus: undefined,
  ShipmentTerms: undefined,
  ShipperCity: undefined,
  ShipperName: undefined,
  ShipperState: undefined,
  ShipperZip: undefined,
  SoNo: undefined,
  shipmentOriginator: undefined,
  VendorKey: undefined,
});
export const getSearchQuoteDefaultFilters = () => ({
  bidAge: null,
  consigneeCity: '',
  consigneeCountry: '',
  consigneePort: '',
  createdBy: '',
  expectedShipFromDate: '',
  expectedShipTodate: '',
  hazardousClass: '',
  pageNumber: 1,
  pageSize: 20,
  poNumber: '',
  quoteNumber: '',
  quotestatus: '',
  shipmentNumber: '',
  shipperCity: '',
  shipperCountry: '',
  shipperPort: '',
  spotQuoteCreatedFrom: moment(new Date()).subtract(1, 'months').format(DEFAULT_DATE_FORMAT),
  spotQuoteCreateTo: moment(new Date()).format(DEFAULT_DATE_FORMAT),
  transportationGroup: '',
  transportationMode: '',
  transporterKey: null,
  urgency: '',
});

export const SHIPMENT_STATUS_FOR_ADVANCED_PLANNING_NOTICE = ['Rated', 'Planning', 'Auto-Rated'];

export const SHIPMENT_PALLET_PACKAGE_TYPE_UOM = {
  CHP: { dimUom: 'C', height: 160, length: 120, width: 100 },
  EUP: { dimUom: 'C', height: 160, length: 120, width: 80 },
};

export const HALEON_SHIPMENT_PALLET_PACKAGE_TYPE_UOM = {
  EUR: { length: 120, width: 80 },
  NAP: { length: 121.9, width: 101.6 },
};

export const PARCEL_EXPRESS_CARRIER_TYPES_FOR_SHIPPER_ACCOUNT = {
  DHLC: 'DHLC',
  FEDX: 'FEDX',
  UPSN: 'UPSN',
};

export const INTEGER_NUMBER_ONLY_VALIDATION_REGEX = /^[0-9][0-9]*$/g;
export const SAVERS_PRODUCT_DIVIDE_VALUE = 23;

export const SHIPMENT_STATUSES = {
  DRAFT: 'Draft',
  PRE_BOOKING: 'Pre-Booking',
};

export const PARCEL_EXPRESS_ADDRESS_VALIDATION_CODE = {
  BOTH: 'SC',
  BOTH_EXIST: 'N',
  CONSIGNEE: 'C',
  SHIPPER: 'S',
};

export const PARCEL_EXPRESS_ADDRESS_VALIDATION_MESSAGE = {
  [PARCEL_EXPRESS_ADDRESS_VALIDATION_CODE.SHIPPER]: 'Do you want to add Shipper address to address book?',
  [PARCEL_EXPRESS_ADDRESS_VALIDATION_CODE.CONSIGNEE]: 'Do you want to add Consignee address to address book?',
  [PARCEL_EXPRESS_ADDRESS_VALIDATION_CODE.BOTH]: 'Do you want to add Shipper and Consignee address to address book?',
};
